module.exports = __webpack_public_path__ + "static/Touchless_MonthTwo-6-505e47e0a2f73e5dac21a57a4d61cbd6.jpg";